(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/data-table", [], factory);
	else if(typeof exports === 'object')
		exports["data-table"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["data-table"] = factory();
})(this, function() {
return 